import React from 'react';
import Icon from '../../../components/AppIcon';

const LanguageFeatures = () => {
  const features = [
    {
      icon: "Globe",
      title: "Instant Translation",
      description: "All content updates immediately in your selected language"
    },
    {
      icon: "Save",
      title: "Preference Saved",
      description: "Your language choice is remembered for future visits"
    },
    {
      icon: "Zap",
      title: "No Interruption",
      description: "Continue your booking without losing any progress"
    },
    {
      icon: "Shield",
      title: "Native Support",
      description: "Proper formatting for dates, currency, and numbers"
    }
  ];

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 gap-4">
      {features?.map((feature, index) => (
        <div
          key={index}
          className="bg-card rounded-xl p-4 border border-border hover:border-accent/50 transition-all duration-200"
        >
          <div className="flex items-start gap-3">
            <div className="w-10 h-10 rounded-lg bg-accent/10 flex items-center justify-center flex-shrink-0">
              <Icon name={feature?.icon} size={20} color="var(--color-accent)" />
            </div>
            <div className="flex-1">
              <h4 className="text-sm font-semibold text-foreground mb-1">
                {feature?.title}
              </h4>
              <p className="text-xs text-muted-foreground leading-relaxed">
                {feature?.description}
              </p>
            </div>
          </div>
        </div>
      ))}
    </div>
  );
};

export default LanguageFeatures;